"use client"

import { useSelector } from "react-redux"
import { selectCategories } from "../../../../redux/shop/selectors"
import { Link } from "react-router-dom"
import { useState, useEffect } from "react"

import { CategoriesStyled, SubCategoriesStyled, CategoryItem, CategoryLink } from "./Categories.styled"

export const Categories = ({ onClick }) => {
    const categories = useSelector(selectCategories)
    const [activeCategory, setActiveCategory] = useState(null)
    const [isMobile, setIsMobile] = useState(false)
    const [clickedCategory, setClickedCategory] = useState(null)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        checkMobile()
        window.addEventListener("resize", checkMobile)

        return () => window.removeEventListener("resize", checkMobile)
    }, [])

    const handleCategoryInteraction = (categoryId, hasSubcategories) => {
        if (isMobile && hasSubcategories) {
            setClickedCategory(clickedCategory === categoryId ? null : categoryId)
        } else if (!isMobile) {
            setActiveCategory(categoryId)
        }
    }

    const handleMouseLeave = () => {
        if (!isMobile) {
            setActiveCategory(null)
        }
    }

    const shouldShowSubcategories = (categoryId) => {
        return isMobile ? clickedCategory === categoryId : activeCategory === categoryId
    }

    return (
        <CategoriesStyled name="categories">
            <ul>
                {categories.map((category) => (
                    <CategoryItem
                        key={category.id}
                        onMouseEnter={() => !isMobile && setActiveCategory(category.id)}
                        onMouseLeave={handleMouseLeave}
                        $hasSubcategories={category.subCatalogs?.length > 0}
                        $isMobile={isMobile}
                    >
                        <CategoryLink
                            to={category.subCatalogs?.length > 0 && isMobile ? "#" : `/shop/${category.id}`}
                            onClick={(e) => {
                                if (category.subCatalogs?.length > 0 && isMobile) {
                                    e.preventDefault()
                                    handleCategoryInteraction(category.id, true)
                                } else {
                                    onClick && onClick()
                                }
                            }}
                        >
                            <span>{category.name}</span>
                            {category.subCatalogs?.length > 0 && (
                                <svg
                                    className={`chevron-icon ${shouldShowSubcategories(category.id) ? "rotated" : ""}`}
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                >
                                    <polyline points="9,18 15,12 9,6"></polyline>
                                </svg>
                            )}
                        </CategoryLink>

                        {/* Показываем subCatalogs */}
                        {shouldShowSubcategories(category.id) && category.subCatalogs?.length > 0 && (
                            <SubCategoriesStyled $isMobile={isMobile}>
                                <ul>
                                    {category.subCatalogs.map((sub) => (
                                        <li key={sub.id}>
                                            <Link
                                                to={`/shop/${sub.id}`}
                                                onClick={() => {
                                                    onClick && onClick()
                                                    if (isMobile) {
                                                        setClickedCategory(null)
                                                    }
                                                }}
                                            >
                                                {sub.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </SubCategoriesStyled>
                        )}
                    </CategoryItem>
                ))}
            </ul>
        </CategoriesStyled>
    )
}
